import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DropOffPoint } from '../models/dropoffpoint';
import { ApiProvider } from '../providers/api.provider';

@Injectable({
  providedIn: 'root'
})
export class DropoffpointService {
  private currentDropOffPointSubject: BehaviorSubject<DropOffPoint[]>;
  public currentDropOffPoint: Observable<DropOffPoint[]>;
  public RouteID: number = 0;
  constructor(private apiProvider: ApiProvider) {
    this.currentDropOffPointSubject = new BehaviorSubject<DropOffPoint[]>(null);
  }

  public get currentDropOffPointValue(): DropOffPoint[] {
    return this.currentDropOffPointSubject.value;
  }

  async initialiseDropOffPoint() {
    this.apiProvider.GetDropOffPointByRoute(this.RouteID).subscribe(
      (dropOffPoint: DropOffPoint[]) => {
        this.currentDropOffPointSubject = new BehaviorSubject<DropOffPoint[]>(
          dropOffPoint
        );
        this.currentDropOffPoint =
          this.currentDropOffPointSubject.asObservable();
      },
      (err: HttpErrorResponse) => {
        this.currentDropOffPointSubject.next(null);
      }
    );
  }
}
